<script lang="ts">
  import Button from "../components/atoms/Button.svelte";
  import Heading from "../components/atoms/Heading.svelte";
  import MicroCard from "../components/organisms/MicroCard.svelte";
  import QueryClientDecorator from "../helpers/QueryClientDecorator.svelte";

  interface Props {
    location?: string;
    micro_tax_code: number;
    micro_no_tax_code: number;
    microoffer_text: string;
  }

  let {
    location = "/elavtal/mikroproduktion",
    micro_tax_code,
    micro_no_tax_code,
    microoffer_text,
  }: Props = $props();
</script>

<QueryClientDecorator>
  <Heading>Beställ elavtal och mikroproduktionsavtal</Heading>
  <MicroCard
    microIdNoTaxCode={micro_no_tax_code}
    microOfferText={microoffer_text}
    microIdWithTaxCode={micro_tax_code}
    class="border-2 p-4 border-solid border-Neutral400 bg-Neutral200"
    hasTaxId={true}
  />
  <Button href={location} class="w-full" type="button">Fortsätt</Button>
</QueryClientDecorator>
